import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Alert, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getInstitutionsForLoggedUser } from '../../InstitutionActions';
import { getCreditValue } from '../../CreditActions';

function CreditCheckAlert({ institutions }, context) {
    if((institutions || []).length) {
        const noCreditsInstitutions = institutions.filter(institution => (institution.credits || []).filter(credit => credit.name).some(credit => !credit.isUnlimited && parseFloat(credit.value) < 1));
        const lowCreditsInstitutions = institutions.filter(institution => (institution.credits || []).filter(credit => credit.name).some(credit => (
            !credit.isUnlimited && parseFloat(credit.value) < 10
            && !noCreditsInstitutions.find(noCreditInstitution => noCreditInstitution._id === institution._id && noCreditInstitution.credits.find(noCredit => noCredit.type === credit.type && noCredit.value < credit.value))
        )));

        // console.log(lowCreditsInstitutions, noCreditsInstitutions);
        if(lowCreditsInstitutions.length || noCreditsInstitutions.length) {
            return (
                <Alert color={noCreditsInstitutions.length ? 'danger' : 'warning'} className="m-2 text-center">
                    <h4><FontAwesomeIcon icon="exclamation-circle" /> {noCreditsInstitutions.length ? <FormattedMessage id="institutionCreditsInsufficientAlert" defaultMessage="Your credits are exhausted!" /> : <FormattedMessage id="institutionCreditsInsufficientAlert2" defaultMessage="Your credits are soon exhausted!" />}</h4>
                    <ul className="list-unstyled">
                        {noCreditsInstitutions.map(institution => (
                            <li key={institution._id}>
                                <strong>{institution.name}</strong>
                                <ul className="list-unstyled">
                                    {institution.credits.filter(credit => !credit.isUnlimited && credit.value < 1).map(credit => (
                                        <li key={credit.type}>{credit.type}: {credit.value} {credit.isHourly && <FormattedMessage id="hours" defaultMessage="Hour(s)" />}</li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                        {lowCreditsInstitutions.map(institution => (
                            <li key={institution._id}>
                                <strong>{institution.name}</strong>
                                <ul className="list-unstyled">
                                    {institution.credits.filter(credit => !credit.isUnlimited && credit.value > 0 && credit.value < 10).map(credit => (
                                        <li key={credit.type}>{credit.type}: {credit.value} {credit.isHourly && <FormattedMessage id="hours" defaultMessage="Hour(s)" />}</li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                    <br /><Button color="link" size="sm" className="text-warning" tag={Link} to="/page/contact"><FormattedMessage id="insitutionCreditManagerAskText" defaultMessage="You need more credits? Contact us!" /></Button>
                </Alert>
            );
        }
    }
    return null;
}

CreditCheckAlert.propTypes = {
    institutions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

function mapStateToProps(store, props) {
    return {
        institutions: getInstitutionsForLoggedUser(store),
    };
}

export default connect(mapStateToProps)(CreditCheckAlert);
